import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  HaynesProVesaCompleteComponentModel,
  HaynesProVesaComponentDetailTabModel,
  HaynesProVesaRepairTimesByGenartModel
}                                              from '../typings/haynes-pro.vesa-advanced';
import { HaynesProVesaComfortDetailDataModel } from '../typings/haynes-pro.vesa';
import { VehicleModel }                        from '../../../../vehicles/models/vehicle';
import { VesaService }                         from '../vesa.service';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-vesa-component-detail',
  styles: [ require('./haynes-pro.diagnostic-tool.vesa-component-detail.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.vesa-component-detail.component.html')
})
export class HaynesProDiagnosticToolVesaComponentDetailComponent implements OnChanges {

  @Input() comfortData : HaynesProVesaComfortDetailDataModel;
  @Input() data        : HaynesProVesaCompleteComponentModel;
  @Input() source      : 'vesa' | 'comfort_electronics' = 'vesa';
  @Input() vehicle!    : VehicleModel;
  @Input() vehicleId   : number;

  @Output() componentNavigate = new EventEmitter<{ componentId: string; systemTypeId: string }>();

  activeTab            = 0;
  isLoadingRepairTimes = false;

  repairTimesByGenart : Record<string, HaynesProVesaRepairTimesByGenartModel> = {};
  tabs                : Array<HaynesProVesaComponentDetailTabModel>           = [];

  constructor (
    public translateService : TranslateService,
    private vesaService     : VesaService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if (this.source === 'comfort_electronics') {
      if (changes.comfortData || changes.source) {
        this.buildTabs();
      }
      return;
    }

    if (changes.data && this.data) {
      this.buildTabs();
      this.loadRepairTimes();
    }
  }

  private buildTabs () : void {
    if (this.source === 'comfort_electronics') {
      this.tabs = [
        {
          enabled : !!this.comfortData?.schemeUrl,
          key     : 'wiring_diagram',
          titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.WIRING_DIAGRAM'
        }
      ];

      this.activeTab = 0;

      return;
    }

    this.tabs = [
      {
        enabled : !!(this.data.images?.wiring?.concise || this.data.images?.wiring?.extended),
        key     : 'wiring_diagram',
        titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.WIRING_DIAGRAM'
      },
      {
        enabled : !!this.data.images?.ecu_side || !!this.data.images?.connector_side,
        key     : 'ecu_pin_connector',
        titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.ECU_PIN_AND_CONNECTOR'
      },
      {
        enabled : !!this.data.component?.has_location_systems,
        key     : 'location',
        titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.LOCATION'
      },
      {
        enabled : this.data.generic_parts?.length > 0 || !!this.data.images?.component_image,
        key     : 'related_parts',
        titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.RELATED_PARTS'
      },
      {
        enabled : false,
        key     : 'repair_manuals',
        titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.REPAIR_MANUALS'
      },
      {
        enabled : this.data.linked_story_groups?.length > 0,
        key     : 'component_info',
        titleKey: 'COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.COMPONENT_INFORMATION'
      }
    ];

    const firstEnabled = this.tabs.findIndex(t => t.enabled);

    this.activeTab = firstEnabled >= 0 ? firstEnabled : 0;
  }

  private loadRepairTimes () : void {
    const genartIds = ( this.data?.generic_parts || [] )
      .map(part => part?.id)
      .filter(Boolean);

    this.repairTimesByGenart = {};

    if (!genartIds.length || !this.vehicleId) {
      return;
    }

    this.isLoadingRepairTimes = true;

    this.vesaService.getVesaRepairTimesByGenarts(this.vehicleId, genartIds)
    .then(( response : Array<HaynesProVesaRepairTimesByGenartModel> = [] ) => {
      this.repairTimesByGenart = ( response || [] ).reduce(( acc, entry ) => {
        if (entry?.genart_id != null) {
          acc[String(entry.genart_id)] = entry;
        }
        return acc;
      }, {} as Record<string, HaynesProVesaRepairTimesByGenartModel>);
    })
    .catch(() => {
      this.repairTimesByGenart = {};
    })
    .finally(() => {
      this.isLoadingRepairTimes = false;
    });
  }
}
